module.exports = __webpack_public_path__ + "img/Laurito.5696e193.png";